import { useCallback } from 'react';
import { useClientContext } from 'client/context';
import { setIndicators } from 'ducks/indicators/slices';
import { useAppDispatch } from 'store/hooks';

export const useConditionLookups = () => {
  const { Voladeum } = useClientContext();
  const dispatch = useAppDispatch();
  return useCallback(async () => {
    const voladeum_indicators = await Voladeum.indicators.list();
    dispatch(setIndicators(voladeum_indicators.data));
  }, [Voladeum.indicators, dispatch]);
};
